import { createSelector } from 'reselect'

export const viewSelector = createSelector(
  (state) => state.app.view,
  (state) => state
)

export const selectSnack = createSelector(
  (state) => state.snack,
  (snack) => snack
)

export const selectDialog = createSelector(
  (state) => state.dialog,
  (state) => state.config.showContextViewStore,
  (dialog) => dialog
)

export const selectProducts = createSelector(
  (state) => state.app.products,
  (state) => state.app.productsLoading,
  (state) => state.app.searchProductResults,
  (state) => state.app.searchLoading,
  (state) => state.app.selected,
  (state) => state.config,
  (products, loading, searchProductResults, loadingSearch, selected, config) => {
    return {
      searchProductResults,
      products,
      fromSearch: !!searchProductResults,
      loading: loadingSearch || loading,
      selected,
      config
    }
  }
)

export const selectStores = createSelector(
  (state) => state.app.stores,
  (state) => state.app.selected,
  (state) => state.app.storesLoading,
  (state) => state.app.currentStore,
  (state) => state.app.showStoreInformation,
  (stores, selectedProducts, loading, currentStore, showStoreInformation) => {
    return { stores, selectedProducts, loading, currentStore, showStoreInformation }
  }
)

export const selectMap = createSelector(
  (state) => state.app.user,
  (state) => state.app.mapState,
  selectStores,
  (state) => state.app.customLocation,
  (state) => state.app.currentStore,
  (state) => state.app.view,
  (state) => state.app.mobileBottomShow,
  (user, mapState, { stores }, customLocation, currentStore, view, showBottom) => ({
    user,
    ...mapState,
    stores,
    customLocation,
    currentStore,
    view,
    showBottom
  })
)

export const selectSearchField = createSelector(
  (state) => state.app.q,
  (state) => state.app.searchLoading,
  (state) => state.app.searchProductResults,
  (state) => state.config.searchPlaceholder,
  (q, loading, searchProductResults, placeholder) => ({
    q,
    canBack: !!searchProductResults,
    loading,
    placeholder
  })
)

export const selectPosition = createSelector(
  (state) => state.position,
  (...args) => args
)

export const selectChart = createSelector(
  (state) => state.chart,
  (...args) => args
)
